import { AuthenticatedApiClient } from './client';
import type { SimpleAccount } from '@/lib/types';

// ===== SimpleAccount対応API関数群 =====

// 認証ヘッダー付きでSimpleAccount一覧を取得
export async function getSimpleAccountsAuthenticated(
  authHeaders: Record<string, string>,
  params?: {
    search?: string;
  },
): Promise<SimpleAccount[]> {
  try {
    const client = new AuthenticatedApiClient(authHeaders);
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('search', params.search);

    const url = `/accounts${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    const accounts = await client.get<SimpleAccount[]>(url);
    return accounts;
  } catch (error) {
    console.error('Failed to fetch simple accounts with auth:', error);
    throw error;
  }
}

// 認証ヘッダー付きでSimpleAccount詳細を取得
export async function getSimpleAccountByIdAuthenticated(
  id: string,
  authHeaders: Record<string, string>,
): Promise<SimpleAccount | null> {
  try {
    const client = new AuthenticatedApiClient(authHeaders);
    const account = await client.get<SimpleAccount>(`/accounts/${id}`);
    return account;
  } catch (error) {
    console.error(`Failed to fetch simple account with id ${id} (authenticated):`, error);
    throw error;
  }
}

// ===== お気に入り関連API関数群 =====

// ユーザーのお気に入りアカウントIDリストを取得
export async function getFavoriteAccountIds(
  authHeaders: Record<string, string>,
): Promise<string[]> {
  try {
    const client = new AuthenticatedApiClient(authHeaders);
    const favoriteIds = await client.get<string[]>('/favorites/accounts');
    return favoriteIds;
  } catch (error) {
    console.error('Failed to fetch favorite account ids:', error);
    throw error;
  }
}

// アカウントをお気に入りに追加
export async function addAccountToFavorites(
  accountId: string,
  authHeaders: Record<string, string>,
): Promise<void> {
  try {
    const client = new AuthenticatedApiClient(authHeaders);
    await client.post(`/favorites/accounts/${accountId}`, {});
  } catch (error) {
    console.error(`Failed to add account ${accountId} to favorites:`, error);
    throw error;
  }
}

// アカウントをお気に入りから削除
export async function removeAccountFromFavorites(
  accountId: string,
  authHeaders: Record<string, string>,
): Promise<void> {
  try {
    const client = new AuthenticatedApiClient(authHeaders);
    await client.delete(`/favorites/accounts/${accountId}`);
  } catch (error) {
    console.error(`Failed to remove account ${accountId} from favorites:`, error);
    throw error;
  }
}
